module.exports = __webpack_public_path__ + "static/media/token-banner.e5c3bcf9.svg";